import React from 'react'
import deniewImg from "./assets/images/AccessDenied.jpg"
import { Link } from 'react-router-dom'
import ConfigUrl from './config'
import { Card } from 'reactstrap'

const PermittedComponent = ({ children, isAccess = false }) => {

    return (
        <>
            {
                isAccess ?
                    children :

                    <Card>
                        <div className='text-center py-5 bg-white'>
                            <div>
                                <img src={deniewImg} alt="" height={400} />
                            </div>
                            <div>
                                <Link to={`${ConfigUrl?.appurl}`} className="btn btn-primary px-4 py-2 fs-5 bg-blue ">
                                    Go to Dashboard
                                </Link>
                            </div>
                        </div>
                    </Card>
            }
        </>
    )
}

export default PermittedComponent